import { attachTabSync } from '@rocketlane/state-db';
import { getTabSync } from '../tab-sync';
import { rolesCollection } from './roles-collection';
export const attachRolesTabSync = ()=>attachTabSync({
        collection: rolesCollection,
        sync: getTabSync()
    });
